module.exports = __webpack_public_path__ + "teacher-and-students.png";